<ng-container *ngIf="isErrorsVisible$ | async">
  <div *ngFor="let error of errors$ | async" [@fadeInOut] class="form-field-errors" [ngClass]="containerClass">
    {{ error }}
  </div>
</ng-container>
